import { Action, ThunkAction, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import localStorage from "redux-persist/es/storage";
import sessionStorage from "redux-persist/lib/storage/session";
import alertReducer from "slices/alert";
import appReducer from "slices/app";
import confirmationReducer from "slices/confirmation";
import detailsReducer from "slices/details";
import languageReducer from "slices/language";
import pageControlReducer from "slices/pageControl";
import passengerReducer from "slices/passenger";
import summaryReducer from "slices/summary";
import poolsReducer from "slices/pools";
import resourceServiceReducer from "slices/resourceService";
import retrieveReducer from "slices/retrieve";
import { getEnv } from "app/utils";

const retrievePersistConfig = {
  key: "retrieve",
  storage: localStorage,
};

const detailsPersistConfig = {
  key: "details",
  storage: sessionStorage,
};

const pageControlPersistConfig = {
  key: "pageControl",
  storage: sessionStorage,
};

const passengerPersistConfig = {
  key: "passengers",
  storage: sessionStorage,
};

const summaryPersistConfig = {
  key: "summary",
  storage: sessionStorage,
};

const confirmationPersistConfig = {
  key: "confirmation",
  storage: sessionStorage,
};

const languagePersistConfig = {
  key: "language",
  storage: localStorage,
};

const persistedRetrieveReducer = persistReducer(
  retrievePersistConfig,
  retrieveReducer,
);
const persistedDetailsReducer = persistReducer(
  detailsPersistConfig,
  detailsReducer,
);
const persistedPageControlReducer = persistReducer(
  pageControlPersistConfig,
  pageControlReducer,
);
const persistedPassengerReducer = persistReducer(
  passengerPersistConfig,
  passengerReducer,
);
const persistedSummaryReducer = persistReducer(
  summaryPersistConfig,
  summaryReducer,
);
const persistedConfirmationReducer = persistReducer(
  confirmationPersistConfig,
  confirmationReducer,
);
const persistedLanguageReducer = persistReducer(
  languagePersistConfig,
  languageReducer,
);

export const store = configureStore({
  reducer: {
    retrieve: persistedRetrieveReducer,
    details: persistedDetailsReducer,
    pageControl: persistedPageControlReducer,
    passenger: persistedPassengerReducer,
    summary: persistedSummaryReducer,
    confirmation: persistedConfirmationReducer,
    pools: poolsReducer,
    alert: alertReducer,
    app: appReducer,
    resourceService: resourceServiceReducer,
    language: persistedLanguageReducer,
  },
  middleware: [],
});

if(process.env.NODE_ENV === "development" || getEnv("VITE_EXPOSE_STORE", false)) {
  window.store = store;
}

export const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
